import React, { useState, useEffect } from 'react';
import './RenameProjectModal.css';

const RenameProjectModal = ({ isOpen, project, onRename, onCancel }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (isOpen && project) {
      setTitle(project.title || '');
      setDescription(project.description || '');
    }
  }, [isOpen, project]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (title.trim()) {
      onRename({
        title: title.trim(),
        description: description.trim()
      });
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="rename-modal-backdrop" onClick={handleBackdropClick}>
      <div className="rename-modal-content">
        <h2>Rename Project</h2>
        <form onSubmit={handleSubmit}>
          <div className="rename-modal-field">
            <label htmlFor="project-title">Project Title *</label>
            <input
              id="project-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter project title"
              required
              autoFocus
            />
          </div>
          <div className="rename-modal-field">
            <label htmlFor="project-description">Project Description</label>
            <textarea
              id="project-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter project description (optional)"
              rows={3}
            />
          </div>
          <div className="rename-modal-actions">
            <button type="button" onClick={onCancel} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="save-button">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RenameProjectModal;